/*----------------------------------
- DEPENDANCES
----------------------------------*/

// App
import type { ContactLeadCallbackType, ContactLeadTopic } from '@/common/types/marketing/contactLead';

/*----------------------------------
- TYPES
----------------------------------*/

export type ContactTopicOption = {
    value: ContactLeadTopic;
    label: string;
    description: string;
};

export type ContactCallbackOption = {
    value: ContactLeadCallbackType;
    label: string;
};

/*----------------------------------
- CONSTANTS
----------------------------------*/

export const CONTACT_TOPIC_OPTIONS: readonly ContactTopicOption[] = [
    {
        value: 'general',
        label: 'General question',
        description: 'Use this for anything that does not fit another topic.',
    },
    {
        value: 'api-access',
        label: 'API access',
        description: 'Request credentials, docs context, or integration support.',
    },
    {
        value: 'product-demo',
        label: 'Product demo',
        description: 'See the CrossPath tool and discuss your workflow.',
    },
    {
        value: 'partnership',
        label: 'Partnership',
        description: 'Talk about affiliate, deal partner, or delivery models.',
    },
    {
        value: 'hiring-support',
        label: 'Hiring support',
        description: 'Share a hiring need or recruitment delivery question.',
    },
] as const;

export const CONTACT_CALLBACK_OPTIONS: readonly ContactCallbackOption[] = [
    { value: 'email', label: 'Email reply' },
    { value: 'video', label: 'Video call' },
    { value: 'whatsapp', label: 'WhatsApp message' },
] as const;

export const CONTACT_DEFAULT_MESSAGE_BY_TOPIC: Record<ContactLeadTopic, string> = {
    general: '',
    'api-access': 'I would like to request API access and discuss the integration setup.',
    'product-demo': 'I would like to book a product demo and share context about my team.',
    partnership: 'I would like to discuss a potential CrossPath partnership.',
    'hiring-support': 'I would like to discuss hiring support for an open role or team need.',
};
